module.exports = __webpack_public_path__ + "img/qr-lpc-ios.77ed52cd.png";